// extracted by mini-css-extract-plugin
export default {"container":"MultiPinInformation_container__KwDLG","address":"MultiPinInformation_address__HmZJg"};